import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PlatformLocation } from '@angular/common';
export interface ConfirmModel {
  title:string;
  message:string;
  extraText:string;
  iconImage:string;
}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper"><div class="modal-dialog">
    <div class="modal-content">

    <div class="poupupTitle">
    <h5 class="modal-title">{{title || 'Confirm'}}</h5>
  </div>
   
       <div class="modal-body personalizePopup  text-center">
       <div class="firstPopup">
         <h3>{{message || 'Are you sure?'}}</h3>
         </div>
       </div>
       <div class="modal-footer" style="text-align:center">
         <button type="button" class="btn btn-default btn-orange text-center" (click)="confirm()">Ok</button>
         <button type="button" class="btn btn-default btn-orange text-center" (click)="close()">Cancel</button>
         </div>
     </div>
  </div></div>`
            })
export class ZizDeleteConfirmComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  isDisabled=false;
  message: string;
  extraText: string;
  iconImage:string;
  rerenderLogoutpopup: boolean;
  constructor(dialogService: DialogService, location: PlatformLocation) {    
    super(dialogService);
     this.rerenderLogoutpopup =true;
      location.onPopState(() => {
     this.close();
    });
   
  }
  public confirm() {
    this.isDisabled=true;
    this.close();
    this.result = true;
    
  }
  cancel() {
     this.result = false;
    this.close();
  }


}



// WEBPACK FOOTER //
// ./src/app/users/popup/ziz-delete-confirm.component.ts